// Styles
import "./VGrid.css";

// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VSpacer = createSimpleFunctional('v-spacer', 'div', 'VSpacer');
//# sourceMappingURL=VSpacer.mjs.map